import { render, staticRenderFns } from "./interpretation-judgement-subjects.vue?vue&type=template&id=59744172&scoped=true&"
import script from "./interpretation-judgement-subjects.vue?vue&type=script&lang=js&"
export * from "./interpretation-judgement-subjects.vue?vue&type=script&lang=js&"
import style0 from "./interpretation-judgement-subjects.vue?vue&type=style&index=0&id=59744172&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59744172",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VForm,VRow})
